import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param page
 * @param entityId
 * @param entityType
 * @param addressId
 * @param limit
 * @param tenantId
 * @param paymentId
 * @param payload
 */
class PaymentOutgoingServices {
  /**
   * @param {*} page
   * @param {*} limit
   * @param {*} tenantId
   * @param {*} paymentId
   * @param {*} tenantRoleId
   * @param status
   * @param {*}paymentType
   * @param tenantSellerId
   * @param approvalStatus
   * @param searchKeyword
   * @return
   */
  getPaymentsOutgoing = async (page, limit, tenantId, tenantSellerId, status, tenantRoleId, approvalStatus, paymentType, searchKeyword, customerId, sellerId, isExpense, appliedPaymentType) => {
    let url = `${Constants.PAYMENT_OUTGOING}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (tenantSellerId) url += `tenant_seller_id=${tenantSellerId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (status) url += `status=${status}&`;
    if (tenantRoleId) url += `tenant_role_id=${tenantRoleId}&`;
    if (approvalStatus) url += `approval_status=${approvalStatus}&`;
    if (paymentType) url += `payment_type=${paymentType}&`;
    if (customerId) url += `customer_id=${customerId}&`;
    if (sellerId) url += `seller_id=${sellerId}&`;
    if (isExpense) url += `is_expense=${isExpense}&`;
    if (appliedPaymentType) url += `applied_payment_types=${appliedPaymentType}&`;
    const paymentOutgoing = await Helpers.get({
      url: `${url}`,
    });
    return paymentOutgoing;
  }

  /**
   * @param {*} page
   * @param {*} limit
   * @param {*} tenantId
   * @param {*} tenantRoleId
   * @return
   */
  getApprovedOnlinePayments = async (page, limit, tenantId, tenantRoleId) => {
    let url = `${Constants.PAYMENT_OUTGOING}?`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (tenantRoleId) url += `tenant_role_id=${tenantRoleId}&`;

    const approvedPayments = await Helpers.get({
      url: `${url}`,
    });
    return approvedPayments;
  }

  /**
   * @param {*} tenantId
   * @param {*} paymentId
   * @return
   */
  getPaymentOutgoingById = async (tenantId, paymentId, paymentType) => {
    let url = `${Constants.PAYMENT_OUTGOING}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (paymentId) url += `payment_id=${paymentId}&`;
    if (paymentType) url += `applied_payment_types=${paymentType}&`;
    const paymentOutgoing = await Helpers.get({
      url: `${url}`,
    });
    return paymentOutgoing;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createPaymentsOutgoing = async (payload) => {
    const createPaymentsOutgoing = await Helpers.post({
      url: Constants.PAYMENT_OUTGOING,
      data: payload,
    });
    return createPaymentsOutgoing;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updatePaymentsOutgoing = async (payload) => {
    const updatePaymentsOutgoing = await Helpers.put({
      url: Constants.PAYMENT_OUTGOING,
      data: payload,
    });
    return updatePaymentsOutgoing;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updatePaymentsOutgoingStatus = async (payload) => {
    const updatePaymentsOutgoingStatus = await Helpers.put({
      url: Constants.PAYMENT_OUTGOING_STATUS,
      data: payload,
    });
    return updatePaymentsOutgoingStatus;
  }

  /**
   * @param paymentId
   * @return {Promise<*>}
   */
  deletePaymentOutgoing = async (paymentId) => {
    const deletePaymentOutgoing = await Helpers.delete({
      url: `${Constants.PAYMENT_OUTGOING}${paymentId ? `?payment_id=${paymentId}` : ''}`,
    });
    return deletePaymentOutgoing;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createAndLinkPayment = async (payload) => {
    const createAndLinkPayment = await Helpers.post({
      url: Constants.CREATE_AND_LINK_PAYMENT,
      data: payload,
    });
    return createAndLinkPayment;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  linkPayment = async (payload) => {
    const linkPayment = await Helpers.post({
      url: Constants.LINK_PAYMENT,
      data: payload,
    });
    return linkPayment;
  }

  /**
   * @param grnPaymentId
   * @param {*} payload
   * @return
   */
  unLinkPayment = async (grnPaymentId) => {
    const linkPayment = await Helpers.delete({
      url: `${Constants.UNLINK_PAYMENT}${grnPaymentId ? `?grn_payment_id=${grnPaymentId}` : ''}`,
    });
    return linkPayment;
  }

  // UNLINKING PO ADVANCE PAYMENT

  unlinkPOAdvancePayment = async (payload) => {
    const unlinkPOAdvancePayment = await Helpers.delete({
      url: Constants.UNLINK_PO_ADVANCE_PAYMENT,
      data: payload,
    });
    return unlinkPOAdvancePayment;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  updatePaymentOutgoingStatus = async (payload) => {
    const updatePaymentOutgoingStatus = await Helpers.put({
      url: Constants.UPDATE_PAYMENT_OUTGOING_STATUS,
      data: payload,
    });
    return updatePaymentOutgoingStatus;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  updatePaymentOutgoingWorkflow = async (payload) => {
    const updatePaymentOutgoingWorkflow = await Helpers.post({
      url: Constants.UPDATE_PAYMENT_OUTGOING_WORKFLOW,
      data: payload,
    });
    return updatePaymentOutgoingWorkflow;
  }

  // download payment outgoing
  downloadPaymentOutgoing = async (payload) => {
    const downloadPaymentOutgoing = await Helpers.post({
      url: `${Constants.PAYMENT_OUTGOING}/download`,
      data: payload,
    });
    return downloadPaymentOutgoing;
  }
}
export default new PaymentOutgoingServices();
